@if (classEnrollments.length > 0) {
  <div class="ontario-row">
    @if (isLearnersDetailsInComplete) {
      <div class="ontario-small-12 ontario-large-6 ontario-medium-8 learner-banner-pos">
        <app-alert-banner bannerType="warning" [bannerText]="translateService.instant('ClassEnrolment.IncompleteLearner')">
        </app-alert-banner>
      </div>
    }
    @if (canDisableSubmitROC) {
      <div class="ontario-margin-top-24-! ontario-margin-bottom-12-! ontario-small-12 ontario-large-8 ontario-medium-8"
        >
        <app-alert-banner bannerType="critical" [bannerText]="translateService.instant('ClassEnrolment.RecordOfSubmissionAlert')">
        </app-alert-banner>
      </div>
    }
  </div>
  <div class="enrollment-card ontario-row ontario-margin-top-16-!">
    <div class="card-title-div">
      <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
        <app-checkbox #masterCheckBox (checkedChange)="setChildCheckBox($event)"> </app-checkbox>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
        <div class="card-label">{{'Contact.FirstName' | translate}}</div>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
        <div class="card-label">{{'Contact.LastName' | translate}}</div>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-3 ontario-medium-6">
        <div class="card-label">{{'ClassEnrolment.Email' | translate}}</div>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
        <div class="card-label">{{'ClassEnrolment.Phone' | translate}}</div>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
        <div class="card-label">{{'ClassEnrolment.Updated' | translate}}</div>
      </div>
      <div class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6"></div>
    </div>
    <div>
      @for (classEnrollment of classEnrollments ; track classEnrollment) {
        <div>
          @for (enrolment of classEnrollment.Enrolments; track enrolment) {
            <div class="ontario-row card-content">
              <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6 banner-container" >
                <app-checkbox class="child-checkbox" #childCheckBox (checkedChange)="setMasterCheckBox($event, enrolment.RegistrationId)"> </app-checkbox>
                @if (enrolment.isInfoIncomplete) {
                  <label  matTooltip="{{'ClassEnrolment.EnrolIncompleteInfo' | translate}}" class="incomplete-info-badge info-banner-pos"></label>
                }
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
                <div class="card-info word-break">{{enrolment?.FirstName}}</div>
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
                <div class="card-info word-break">{{enrolment?.LastName}}</div>
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-3 ontario-medium-6">
                <div class="card-info break-all">{{enrolment?.EmailAddress}}</div>
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
                <div class="card-info">{{enrolment?.Phone | phone}}</div>
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6">
                <div class="card-info">{{classEnrollment.Enrolments[0].LastUpdatedDate | utcToLocalDateTime:'MMM dd, yyyy':currentLang}}</div>
              </div>
              <div class="ontario-column ontario-small-12 ontario-large-3 ontario-medium-6">
                <div class="ontario-column ontario-small-12 ontario-large-9 ontario-medium-6">
                  @if (enrolmentStatus== 'pending') {
                    <label class="card-title-badge status-pending">{{'ClassEnrolment.EnrolmentRequestPending' | translate}}</label>
                  }
                  @if (enrolmentStatus== 'enrolled') {
                    <label class="card-title-badge status-enrolled">{{'ClassEnrolment.Enrolled' | translate}}</label>
                  }
                  @if (enrolmentStatus== 'cancelled') {
                    <label class="card-title-badge status-cancelled">{{'ClassEnrolment.Cancelled' | translate}}</label>
                  }
                  @if (enrolmentStatus== 'SuccessfullyCompleted') {
                    <label class="card-title-badge status-enrolled">{{'ClassEnrolment.SuccessfullyCompleted' | translate}}</label>
                  }
                </div>
                <div class="ontario-column ontario-small-12 ontario-large-3 ontario-medium-12 ">
                  <a class="view-link" [routerLink]="this.currentLang == 'en'? '/training-provider/enrolment/' + classEnrollments[0].Enrolments[0].CourseId + '/tp':'/fr/training-provider/enrolment/' + classEnrollments[0].Enrolments[0].CourseId + '/tp'"
                  [queryParams]="{GroupOrRegId: enrolment.RegistrationId, EnrollmentFlowType: ENROLLMENT_FLOW_TYPE.EnrolledView, Status: enrolmentStatus}">Details</a>
                </div>
              </div>
            </div>
            <div class="ontario-row contentBox">
              <div class="ontario-column no-padding">
                <div class="rowDevider ontario-small-12"></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

